var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 13.6673C3.31865 13.6673 0.333984 10.6827 0.333984 7.00065C0.333984 3.31865 3.31865 0.333984 7.00065 0.333984C10.6827 0.333984 13.6673 3.31865 13.6673 7.00065C13.6673 10.6827 10.6827 13.6673 7.00065 13.6673ZM7.00065 12.334C8.41514 12.334 9.77169 11.7721 10.7719 10.7719C11.7721 9.77169 12.334 8.41514 12.334 7.00065C12.334 5.58616 11.7721 4.22961 10.7719 3.22941C9.77169 2.22922 8.41514 1.66732 7.00065 1.66732C5.58616 1.66732 4.22961 2.22922 3.22941 3.22941C2.22922 4.22961 1.66732 5.58616 1.66732 7.00065C1.66732 8.41514 2.22922 9.77169 3.22941 10.7719C4.22961 11.7721 5.58616 12.334 7.00065 12.334ZM6.33398 9.00065H7.66732V10.334H6.33398V9.00065ZM6.33398 3.66732H7.66732V7.66732H6.33398V3.66732Z",
    fill: "#F65166"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.faaf6197.svg";
export { ForwardRef as ReactComponent };